import https from "@/services/";

let failedQueue = [], verrou = false, _retry = 0;

const processQueue = (e = null) => {
    failedQueue.forEach(p => e ?
        p.reject(e) : p.resolve());
    failedQueue = [];
}

const grant = (userRoles = [], requiredRoles) => {
    if (!userRoles || !requiredRoles) return false;

    const roles = userRoles.map(r => r.toUpperCase());

    return Array.isArray(requiredRoles)
        ? requiredRoles.some(r => roles.includes(r.toUpperCase()))
        : roles.includes(requiredRoles.toUpperCase());
};

const getUserRoles = (store) => {
    const user = store?.getters?.['auth/user'];
    if (!user) return [];

    return [
        ...(user.roles || []),
        ...(user.clientRoles || [])
    ].map(r => r.toUpperCase());
};

const test = (meta, store) => {
    const user = store.getters['auth/isLogged'];
    if(user) return true;
    else return false;
    //if(meta.isBvm && user.isBvm) return true;
    //else return false;
};

export default {
    grant,
    middleware: async ({ to, store, next }) => {

        const isAuthenticated = store.getters['auth/isAuthenticated'];
        const user = store.getters['auth/user'];

        // 🔐 Vérifie toute la chaîne de routes (parents inclus)
        const requiresAuth = to.matched.some(r => r.meta?.requiresAuth);
        const isPublic = to.matched.some(r => r.meta?.public);

        // 🔴 Accès protégé sans authentification
        if (requiresAuth && !isAuthenticated) {
            return next({
                name: 'login',
                query: { redirect: to.fullPath }
            });
        }

        // 🚫 Empêcher retour sur login si déjà connecté
        if (isAuthenticated && to.name === 'login') {
            return next({ name: 'dashboard' });
        }

        // 🔁 Root → dashboard si connecté
        if (to.path === '/' && isAuthenticated) {
            return next({ name: 'dashboard' });
        }

        // 🟢 Route publique
        if (!requiresAuth || isPublic) {
            return next();
        }

        // 🎭 Vérification des rôles
        const userRoles = user
            ? [...(user.roles || []), ...(user.clientRoles || [])].map(r => r.toUpperCase())
            : [];

        if (to.meta.roles?.length) {
            const hasAccess = to.meta.roles.some(r =>
                userRoles.includes(r.toUpperCase())
            );

            if (!hasAccess) {
                store.commit('TOGGLE');
                return next({
                    name: 'errorPage',
                    query: { redirect: to.fullPath }
                });
            }
        }

        // ✅ Autorisé
        return next();
    },

    interceptor(error, store, router) {
        const {response, config} = error, token = JSON.parse(localStorage.getItem("authoken"));
        if (!response) return Promise.reject(error);
        const {status, data} = response

        if (token && status === 401) {
            if (_retry > 2) {
                processQueue(data);
                return store.dispatch("auth/logout").then(() =>
                    router.replace({
                        name: 'home', query: {
                            redirect: (router.currentRoute || {}).fullPath
                        }
                    }).then(() => store.commit('TOGGLE'))
                )
            } else if (verrou) return new Promise((resolve, reject) => failedQueue.push({
                resolve,
                reject
            })).then(() => https.request(config)).catch(err => Promise.reject(err));

            verrou = true;
            _retry++;
            store.dispatch("auth/login", {
                grant_type: "refresh_token",
                refresh_token: token.refresh
            }).then(({access_token}) => {
                console.debug(access_token);
                processQueue();
                return https.request(config).then(() => _retry = 0);
            });
            verrou = false;
        }
        return Promise.reject(response);
    }
};